import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { MarqueeRibbon } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { Properties } from "../components/Properties";
import { Services } from "../components/Services";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { InstagramMural } from "../components/InstagramMural";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => window.__lenis?.scrollTo(location.hash, { offset: -80 }), 400);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <MarqueeRibbon />
      <Manifesto />
      <Properties />
      <Services />
      <Testimonials />
      <Contact />
      <InstagramMural />
    </main>
  );
}
